import React, { useId } from 'react';
import styles from './Input.module.css';

const clsx = (...args) => args.filter(Boolean).join(' ');

const Input = React.forwardRef(function Input(
  {
    label,
    helpText,
    error,
    tone = 'light',
    size = 'md',
    id,
    leadingIcon,
    trailingIcon,
    trailingInteractive = false,
    className,
    ...rest
  },
  ref
) {
  const errorId = useId();
  const wrapCls = clsx(
    styles.wrap,
    tone === 'dark' && styles.onDark,
    size !== 'md' && styles[size],
    error && styles.error
  );

  const inputWrapCls = clsx(
    styles.inputWrap,
    leadingIcon && styles.hasLeading,
    trailingIcon && styles.hasTrailing
  );

  return (
    <div className={wrapCls}>
      {label && (
        <label className={styles.label} htmlFor={id}>
          {label}
        </label>
      )}
      <div className={inputWrapCls}>
        {leadingIcon && <span className={styles.leading}>{leadingIcon}</span>}
        <input
          ref={ref}
          id={id}
          className={clsx(styles.field, className)}
          aria-invalid={!!error}
          aria-describedby={error ? errorId : undefined}
          {...rest}
        />
        {trailingIcon && (
          <span
            className={clsx(
              styles.trailing,
              trailingInteractive && styles.interactive
            )}
          >
            {trailingIcon}
          </span>
        )}
      </div>
      {(helpText || error) && (
        <span className={styles.helpText} id={error ? errorId : undefined}>
          {error || helpText}
        </span>
      )}
    </div>
  );
});

export default Input;
